module.exports = __webpack_public_path__ + "static/media/kenja_400sc.76caae49.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/botrytis_fresa/curativa/kenja_400sc.png
// module id = 1542
// module chunks = 3